import { useState, useEffect } from "react";

// react-router components
import { useLocation, Link } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @material-ui core components
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import Breadcrumbs from "theme/Breadcrumbs";

// Custom styles for DashboardNavbar
import {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
  navbarMobileMenu,
} from "app/Navbars/DashboardNavbar/styles";

// Material Dashboard 2 React context
import {
  useMaterialUIController,
  setTransparentNavbar,
  setMiniSidenav,
  // setOpenConfigurator,
  // setDarkMode,
} from "context";

// @mui material components
import { Alert } from "@mui/material";
import AppConfig from "appConfig";
import ProfilerDialog from "app/components/profiler";
// import AgentFeedback from "app/components/feedback_dialog";

function DashboardNavbar({ absolute, light, isMini }) {
  const [navbarType, setNavbarType] = useState();
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, transparentNavbar, fixedNavbar, darkMode } = controller;
  const route = useLocation().pathname.split("/").slice(1);

  const [displayState, setDisplayState] = useState(false);
  useEffect(() => {
    // Setting the navbar type
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }

    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      setTransparentNavbar(dispatch, (fixedNavbar && window.scrollY === 0) || !fixedNavbar);
    }

    /** 
     The event listener that's calling the handleTransparentNavbar function when 
     scrolling the window.
    */
    window.addEventListener("scroll", handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  // const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);
  // const handleDarkMode = () => setDarkMode(dispatch, !darkMode);

  // Styles for the navbar icons
  const iconsStyle = ({ palette: { dark, white, text }, functions: { rgba } }) => ({
    color: () => {
      let colorValue = light || darkMode ? white.main : dark.main;

      if (transparentNavbar && !light) {
        colorValue = darkMode ? rgba(text.main, 0.6) : text.main;
      }

      return colorValue;
    },
  });

  return (
    <>
      <AppBar
        position={absolute ? "absolute" : navbarType}
        color="inherit"
        sx={(theme) => navbar(theme, { transparentNavbar, absolute, light, darkMode })}
      >
        <Toolbar sx={(theme) => navbarContainer(theme)}>
          <MDBox color="inherit" mb={{ xs: 1, md: 0 }} sx={(theme) => navbarRow(theme, { isMini })}>
            <Breadcrumbs icon="home" title={route[route.length - 1]} route={route} light={light} />
          </MDBox>
          {isMini ? null : (
            <MDBox sx={(theme) => navbarRow(theme, { isMini })}>
              {/* <MDBox pr={1}>
              <MDInput label="Search here" />
            </MDBox> */}
              <MDBox color={light ? "white" : "inherit"}>
                <IconButton
                  size="small"
                  disableRipple
                  color="inherit"
                  sx={navbarMobileMenu}
                  onClick={handleMiniSidenav}
                >
                  <Icon sx={iconsStyle} fontSize="medium">
                    {miniSidenav ? "menu_open" : "menu"}
                  </Icon>
                </IconButton>
                {/* <Link to="/switch">
                <IconButton sx={navbarIconButton} size="small" disableRipple>
                  <Icon sx={iconsStyle}>paid</Icon>
                </IconButton>
              </Link>
              <Link to="/p2p">
                <IconButton sx={navbarIconButton} size="small" disableRipple>
                  <Icon sx={iconsStyle}>hub</Icon>
                </IconButton>
              </Link>
              <Link to="/convert">
                <IconButton sx={navbarIconButton} size="small" disableRipple>
                  <Icon sx={iconsStyle}>currency_exchange</Icon>
                </IconButton>
              </Link> */}
                <IconButton
                  size="small"
                  disableRipple
                  color="warning"
                  sx={navbarIconButton}
                  onClick={() => setDisplayState(true)}
                >
                  <Icon sx={iconsStyle}>reviews</Icon>
                </IconButton>
                <a href={AppConfig.whatsapp_group_link} target="_blank" rel="noreferrer">
                  <IconButton sx={navbarIconButton} size="small">
                    <WhatsAppIcon color="success">WhatsApp</WhatsAppIcon>
                  </IconButton>
                </a>
                <a href={AppConfig.telegram_group_link} target="_blank" rel="noreferrer">
                  <IconButton sx={navbarIconButton} size="small">
                    <Icon color="info">telegram</Icon>
                  </IconButton>
                </a>
                <Link to="/messages">
                  <IconButton sx={navbarIconButton} size="small" disableRipple>
                    <Icon sx={iconsStyle}>mail</Icon>
                  </IconButton>
                </Link>
                <Link to="/profile">
                  <IconButton sx={navbarIconButton} size="small" disableRipple>
                    <Icon sx={iconsStyle}>account_circle</Icon>
                  </IconButton>
                </Link>
                {/* <IconButton
                size="small"
                disableRipple
                color="inherit"
                sx={navbarIconButton}
                onClick={handleDarkMode}
              >
                <Icon sx={iconsStyle}>contrast</Icon>
              </IconButton> */}
              </MDBox>
            </MDBox>
          )}
        </Toolbar>
      </AppBar>
      {AppConfig.newInbox > 0 ? (
        <MDBox mt={1}>
          <Alert severity="warning" sx={{ width: "100%" }}>
            You have {AppConfig.newInbox} unread {AppConfig.newInbox > 1 ? "messages" : "message"}{" "}
            in your inbox. &nbsp;
            <Link to="/messages">
              View inbox
              <IconButton sx={navbarIconButton} size="small" disableRipple>
                <Icon color="warning">mail</Icon>
              </IconButton>
            </Link>
          </Alert>
        </MDBox>
      ) : (
        <> </>
      )}
      {AppConfig.profile_reqd ? <ProfilerDialog /> : <> </>}
      {/* <AgentFeedback displayState={displayState} setDisplayState={setDisplayState} /> */}
    </>
  );
}

// Setting default values for the props of DashboardNavbar
DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
